<div class="ca-table__container tabla-overflow">
    <table cdk-table [dataSource]="datosTablaMostrados" class="ca-table">
        <ng-container *ngFor="let column of columnas; let i = index" [cdkColumnDef]="column.field">
            <th cdk-header-cell *cdkHeaderCellDef class="ca-table__header" [caResizeColumn]="true">
                <div class="ca-table__header-container justify-content-start">
                    <span class="ca-table__header-wrapper">
                        <span class="ca-table__header-text">{{ column.value }}</span>
                    </span>
                </div>
            </th>
            <td cdk-cell *cdkCellDef="let row; let i = index" class="ca-table__cell">
                <div class="ca-table__cell-container">
                    <span *ngIf="column.field !== 'acciones' else menu" class="ca-table__cell-text ajustar-texto">
                        {{ row[column.field] }}
                    </span>
                    <ng-template #menu>
                        <button ca-button-icon [caMenuTriggerFor]="menu" class="trigger" [closeAllOnOpen]="true">
                            <span class="material-icons">more_vert</span>
                        </button>
                        <ca-menu #menu="caMenu">
                            <ca-menu-item *ngIf="mostrarGuardar" (selected)="emitirGuardar(row)"> {{'MENU.PRIVADO.GUARDAR' | translate}} </ca-menu-item>
                            <ca-menu-item *ngIf="mostrarContratacion" (selected)="emitirContratar(row)"> {{'MENU.PRIVADO.CONTRATAR' | translate}} </ca-menu-item>
                        </ca-menu>
                    </ng-template>
                </div>
            </td>
        </ng-container>
        <thead class="ca-table__thead">
            <tr cdk-header-row *cdkHeaderRowDef="columnasMostradas"
                class="ca-table__row ca-table__row--bordered ca-table__row--clean"></tr>
        </thead>
        <tbody class="ca-table__tbody">     
            <div *ngIf="!registroSeleccionable"> 
                <tr cdk-row *cdkRowDef="let row; columns: columnasMostradas; let i = index" class="ca-table__row" ></tr>
            </div>    
            <div *ngIf="registroSeleccionable">   
                <tr cdk-row *cdkRowDef="let row; columns: columnasMostradas; let i = index"
                    class="ca-table__row"
                    [class.ca-table__row--selected]="isSelectedRow(row)"
                    (click)="onSelectedRow(row, i)"
                    (dblclick)="onDblClick(row)"></tr>
            </div>
        </tbody>
    </table>
    <div class="d-flex justify-content-center ca-table__pagination-wrapper" *ngIf="paginado">
        <ca-pagination [dataSize]="tamanoDatos" [(page)]="pagina" [pageSize]="tamanoPagina" (pageChange)="paginate()">
        </ca-pagination>
    </div>
</div>